import { render, staticRenderFns } from "./QuestionManage.vue?vue&type=template&id=57f0f542&scoped=true"
import script from "./QuestionManage.vue?vue&type=script&lang=js"
export * from "./QuestionManage.vue?vue&type=script&lang=js"
import style1 from "./QuestionManage.vue?vue&type=style&index=1&id=57f0f542&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f0f542",
  null
  
)

export default component.exports